import _defineProperty from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var getVariantStyles = function getVariantStyles() {
  var variant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';
  var theme = arguments.length > 1 ? arguments[1] : undefined;
  var style = {
    default: {
      color: 'btn.text',
      backgroundColor: 'btn.bg',
      boxShadow: "".concat(theme === null || theme === void 0 ? void 0 : theme.shadows.btn.shadow, ", ").concat(theme === null || theme === void 0 ? void 0 : theme.shadows.btn.insetShadow),
      '&:hover:not([disabled])': {
        backgroundColor: 'btn.hoverBg',
        borderColor: "var(--button-default-borderColor-hover, ".concat(theme === null || theme === void 0 ? void 0 : theme.colors.btn.hoverBorder, ")")
      },
      '&:active:not([disabled])': {
        backgroundColor: 'btn.activeBg',
        borderColor: "var(--button-default-borderColor-active, ".concat(theme === null || theme === void 0 ? void 0 : theme.colors.btn.activeBorder, ")")
      },
      '&:disabled': {
        color: 'primer.fg.disabled',
        '[data-component=ButtonCounter]': {
          color: 'inherit'
        }
      },
      '&[aria-expanded=true]': {
        backgroundColor: 'btn.activeBg',
        borderColor: "var(--button-default-borderColor-active, ".concat(theme === null || theme === void 0 ? void 0 : theme.colors.btn.activeBorder, ")")
      },
      '[data-component="leadingVisual"], [data-component="trailingVisual"], [data-component="trailingAction"]': {
        color: "var(--button-color, ".concat(theme === null || theme === void 0 ? void 0 : theme.colors.fg.muted, ")")
      }
    },
    primary: {
      color: 'btn.primary.text',
      backgroundColor: 'btn.primary.bg',
      borderColor: 'btn.primary.border',
      boxShadow: "".concat(theme === null || theme === void 0 ? void 0 : theme.shadows.btn.primary.shadow),
      '&:hover:not([disabled])': {
        color: 'btn.primary.hoverText',
        backgroundColor: 'btn.primary.hoverBg'
      },
      '&:focus:not([disabled])': {
        boxShadow: 'inset 0 0 0 3px'
      },
      '&:focus-visible:not([disabled])': {
        boxShadow: 'inset 0 0 0 3px'
      },
      '&:active:not([disabled])': {
        backgroundColor: 'btn.primary.selectedBg',
        boxShadow: "".concat(theme === null || theme === void 0 ? void 0 : theme.shadows.btn.primary.selectedShadow)
      },
      '&:disabled': {
        color: 'btn.primary.disabledText',
        backgroundColor: 'btn.primary.disabledBg',
        '[data-component=ButtonCounter]': {
          color: 'inherit'
        }
      },
      '[data-component=ButtonCounter]': {
        backgroundColor: 'btn.primary.counterBg',
        color: 'btn.primary.text'
      },
      '&[aria-expanded=true]': {
        backgroundColor: 'btn.primary.selectedBg',
        boxShadow: "".concat(theme === null || theme === void 0 ? void 0 : theme.shadows.btn.primary.selectedShadow)
      }
    },
    danger: {
      color: 'btn.danger.text',
      backgroundColor: 'btn.bg',
      boxShadow: "".concat(theme === null || theme === void 0 ? void 0 : theme.shadows.btn.shadow),
      '&:hover:not([disabled])': {
        color: 'btn.danger.hoverText',
        backgroundColor: 'btn.danger.hoverBg',
        borderColor: 'btn.danger.hoverBorder',
        boxShadow: "".concat(theme === null || theme === void 0 ? void 0 : theme.shadows.btn.danger.hoverShadow),
        '[data-component=ButtonCounter]': {
          backgroundColor: 'btn.danger.hoverCounterBg',
          color: 'btn.danger.hoverCounterFg'
        }
      },
      '&:active:not([disabled])': {
        color: 'btn.danger.selectedText',
        backgroundColor: 'btn.danger.selectedBg',
        boxShadow: "".concat(theme === null || theme === void 0 ? void 0 : theme.shadows.btn.danger.selectedShadow),
        borderColor: 'btn.danger.selectedBorder'
      },
      '&:disabled': {
        color: 'btn.danger.disabledText',
        backgroundColor: 'btn.danger.disabledBg',
        borderColor: 'btn.danger.disabledBorder',
        '[data-component=ButtonCounter]': {
          color: 'btn.danger.disabledCounterFg',
          backgroundColor: 'btn.danger.disabledCounterBg'
        }
      },
      '[data-component=ButtonCounter]': {
        color: 'btn.danger.counterFg',
        backgroundColor: 'btn.danger.counterBg'
      },
      '&[aria-expanded=true]': {
        color: 'btn.danger.selectedText',
        backgroundColor: 'btn.danger.selectedBg',
        boxShadow: "".concat(theme === null || theme === void 0 ? void 0 : theme.shadows.btn.danger.selectedShadow),
        borderColor: 'btn.danger.selectedBorder'
      }
    },
    invisible: {
      color: 'btn.text',
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      boxShadow: 'none',
      '&:hover:not([disabled])': {
        backgroundColor: 'actionListItem.default.hoverBg'
      },
      '&:active:not([disabled])': {
        backgroundColor: 'actionListItem.default.activeBg'
      },
      '&:disabled': {
        color: 'primer.fg.disabled',
        '[data-component=ButtonCounter], [data-component="leadingVisual"], [data-component="trailingAction"]': {
          color: 'inherit'
        }
      },
      '&[aria-expanded=true]': {
        backgroundColor: 'actionListItem.default.selectedBg'
      },
      '&[data-component="IconButton"][data-no-visuals]': {
        color: 'fg.muted'
      },
      '[data-component="trailingAction"]': {
        color: 'fg.muted'
      },
      '[data-component="leadingVisual"]': {
        color: 'fg.muted'
      },
      '&[data-no-visuals]': {
        color: 'accent.fg'
      },
      '&:has([data-component="ButtonCounter"])': {
        color: 'btn.text'
      },
      '&:disabled[data-no-visuals]': {
        color: 'primer.fg.disabled',
        '[data-component=ButtonCounter]': {
          color: 'inherit'
        }
      }
    },
    outline: {
      color: 'btn.outline.text',
      boxShadow: "".concat(theme === null || theme === void 0 ? void 0 : theme.shadows.btn.shadow),
      borderColor: "var(--button-default-borderColor-rest, ".concat(theme === null || theme === void 0 ? void 0 : theme.colors.btn.border, ")"),
      backgroundColor: 'btn.bg',
      '&:hover:not([disabled])': {
        color: 'btn.outline.hoverText',
        backgroundColor: 'btn.outline.hoverBg',
        borderColor: "".concat(theme === null || theme === void 0 ? void 0 : theme.colors.btn.outline.hoverBorder),
        boxShadow: "".concat(theme === null || theme === void 0 ? void 0 : theme.shadows.btn.outline.hoverShadow),
        '[data-component=ButtonCounter]': {
          backgroundColor: 'btn.outline.hoverCounterBg',
          color: 'btn.outline.hoverCounterFg'
        }
      },
      '&:active:not([disabled])': {
        color: 'btn.outline.selectedText',
        backgroundColor: 'btn.outline.selectedBg',
        boxShadow: "".concat(theme === null || theme === void 0 ? void 0 : theme.shadows.btn.outline.selectedShadow),
        borderColor: "".concat(theme === null || theme === void 0 ? void 0 : theme.colors.btn.outline.selectedBorder)
      },
      '&:disabled': {
        color: 'btn.outline.disabledText',
        backgroundColor: 'btn.outline.disabledBg',
        borderColor: 'btn.border',
        '[data-component=ButtonCounter]': {
          backgroundColor: 'btn.outline.disabledCounterBg',
          color: 'btn.outline.disabledCounterFg'
        }
      },
      '[data-component=ButtonCounter]': {
        backgroundColor: 'btn.outline.counterBg',
        color: 'btn.outline.counterFg'
      },
      '&[aria-expanded=true]': {
        color: 'btn.outline.selectedText',
        backgroundColor: 'btn.outline.selectedBg',
        boxShadow: "".concat(theme === null || theme === void 0 ? void 0 : theme.shadows.btn.outline.selectedShadow),
        borderColor: "var(--button-default-borderColor-active, ".concat(theme === null || theme === void 0 ? void 0 : theme.colors.btn.outline.selectedBorder, ")")
      }
    }
  };
  return style[variant];
};
var getBaseStyles = function getBaseStyles(theme) {
  return {
    borderRadius: '2',
    border: '1px solid',
    borderColor: "var(--button-default-borderColor-rest, ".concat(theme === null || theme === void 0 ? void 0 : theme.colors.btn.border, ")"),
    fontFamily: 'inherit',
    fontWeight: 'semibold',
    fontSize: '1',
    cursor: 'pointer',
    appearance: 'none',
    userSelect: 'none',
    textDecoration: 'none',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '32px',
    padding: '0 12px',
    gap: '8px',
    minWidth: 'max-content',
    transition: '80ms cubic-bezier(0.65, 0, 0.35, 1)',
    transitionProperty: 'color, fill, background-color, border-color',
    '&[href]': {
      display: 'inline-flex',
      '&:hover': {
        textDecoration: 'none'
      }
    },
    '&:hover': {
      transitionDuration: '80ms'
    },
    '&:active': {
      transition: 'none'
    },
    '&:disabled': {
      cursor: 'not-allowed',
      boxShadow: 'none'
    },
    '@media (forced-colors: active)': {
      '&:focus': {
        // Support for Windows high contrast https://sarahmhigley.com/writing/whcm-quick-tips
        outline: 'solid 1px transparent'
      }
    },
    '[data-component=ButtonCounter]': {
      fontSize: '0'
    },
    '&[data-component=IconButton]': {
      display: 'inline-grid',
      padding: 'unset',
      placeContent: 'center',
      width: '32px',
      minWidth: 'unset'
    },
    '&[data-size="small"]': {
      padding: '0 8px',
      height: '28px',
      gap: '4px',
      fontSize: '0',
      '[data-component="text"]': {
        lineHeight: 'calc(20 / 12)'
      },
      '[data-component=ButtonCounter]': {
        fontSize: '0'
      },
      '[data-component="buttonContent"] > :not(:last-child)': {
        mr: '4px'
      },
      '&[data-component=IconButton]': {
        width: '28px',
        padding: 'unset'
      }
    },
    '&[data-size="large"]': {
      padding: '0 16px',
      height: '40px',
      gap: '8px',
      '[data-component="buttonContent"] > :not(:last-child)': {
        mr: '8px'
      },
      '&[data-component=IconButton]': {
        width: '40px',
        padding: 'unset'
      }
    }
  };
};
var getButtonStyles = function getButtonStyles(theme) {
  var styles = _objectSpread(_objectSpread({}, getBaseStyles(theme)), {}, {
    '&[data-block="block"]': {
      width: '100%'
    },
    '[data-component="leadingVisual"]': {
      gridArea: 'leadingVisual'
    },
    '[data-component="text"]': {
      gridArea: 'text',
      lineHeight: 'calc(20/14)',
      whiteSpace: 'nowrap'
    },
    '[data-component="trailingVisual"]': {
      gridArea: 'trailingVisual'
    },
    '[data-component="trailingAction"]': {
      marginRight: '-4px'
    },
    '[data-component="buttonContent"]': {
      flex: '1 0 auto',
      display: 'grid',
      gridTemplateAreas: '"leadingVisual text trailingVisual"',
      gridTemplateColumns: 'min-content minmax(0, auto) min-content',
      alignItems: 'center',
      alignContent: 'center'
    },
    '[data-component="buttonContent"] > :not(:last-child)': {
      mr: '8px'
    }
  });
  return styles;
};
var getAlignContentSize = function getAlignContentSize() {
  var alignContent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'center';
  return {
    justifyContent: alignContent === 'center' ? 'center' : 'flex-start'
  };
};
export { getAlignContentSize, getBaseStyles, getButtonStyles, getVariantStyles };